import { defineComponent } from '@ui/components/helpers';
import { s } from '@ui/validation';
import { componentBase } from '@ui/components/schemas';

export const icNavigationDefinition = defineComponent('ic-navigation', {
    base: componentBase,
    props: {
        appearance: s.enum(['default', 'dense', 'compact', 'thin'])
            .describe('Apariencia visual del sidebar. "default" muestra el panel completo y "dense" lo reduce a iconos; el cambio entre ambas se controla por click, sin expansión al hover. "compact" y "thin" se heredan de Fuse'),
        mode: s.enum(['over', 'side'])
            .describe('Modo de posicionamiento: "side" empuja el contenido, "over" se superpone con overlay'),
        name: s.string()
            .describe('Nombre único para registro en FuseNavigationService. Si no se provee, se genera automáticamente')
            .optional(),
        navigation: s.array(s.any())
            .describe('Array requerido de UiNavigationItem[]; admite tipos aside, basic, collapsable, divider, group, spacer, footer y footer-divider'),
        opened: s.boolean()
            .describe('Controla si el panel de navegación está abierto o cerrado'),
        position: s.enum(['left', 'right'])
            .describe('Posición lateral del sidebar en el layout'),
        autoCollapse: s.boolean()
            .describe('Auto-colapsa otros items colapsables cuando uno se expande'),
        inner: s.boolean()
            .describe('Renderiza la navegación en modo interno dentro de un contenedor, comportamiento heredado de Fuse'),
        transparentOverlay: s.boolean()
            .describe('Hace transparente el overlay del modo "over", comportamiento heredado de Fuse'),
    },
    slots: [
        'fuseVerticalNavigationHeader',
        'fuseVerticalNavigationContentFooter',
        'fuseVerticalNavigationFooter',
    ],
    defaults: {
        appearance: 'default',
        mode: 'side',
        opened: true,
        position: 'left',
        autoCollapse: true,
        inner: false,
        transparentOverlay: false,
    },
    description: 'Sidebar de navegación vertical basado en FuseVerticalNavigationComponent. Usa ViewEncapsulation.None y nombrespacia sus estilos bajo el host ic-navigation. Soporta los modos side/over, las apariencias default, dense, compact y thin, cambio por click entre default/dense sin expansión al hover, y UiNavigationItem de tipo aside, basic, collapsable, divider, group, spacer, footer y footer-divider.',
    component: () => import('./navigation.component').then(m => m.IcNavigationComponent),
});
